{
  "dashboard": {
    "title": "Tableau de bord Admin",
    "welcome": "Bienvenue dans le panneau d'administration",
    "description": "Gérez le contenu et les paramètres de la plateforme depuis ici.",
    "placeholder": "Le contenu du tableau de bord sera implémenté ici."
  },
  "navigation": {
    "general": "Général",
    "external": "Externe",
    "dashboard": "Tableau de bord",
    "recommendations": "Recommandations",
    "evaluations": "Évaluations",
    "medias": "Médias",
    "agents": "Agents",
    "users": "Utilisateurs",
    "institutions": "Institutions",
    "subscriptions": "Abonnements",
    "sensoquizz": "SensoQuizz",
    "mobileApp": "Application Mobile",
    "changelog": "Changelog",
    "logoAlt": "Logo MetaDevProfile",
    "brandName": "MetaDevProfile",
    "roles": {
      "admin": "Administrateur"
    }
  },
  "users": {
    "title": "Gestion des Utilisateurs",
    "description": "Gérer les utilisateurs praticiens et leurs profils",
    "form": {
      "basic": "Informations de Base",
      "profile": "Détails du Profil",
      "settings": "Paramètres du Compte",
      "firstName": "Prénom",
      "firstNamePlaceholder": "Entrez le prénom",
      "lastName": "Nom de Famille",
      "lastNamePlaceholder": "Entrez le nom de famille",
      "email": "Adresse Email",
      "emailPlaceholder": "Entrez l'adresse email",
      "phone": "Numéro de Téléphone",
      "phonePlaceholder": "Entrez le numéro de téléphone",
      "password": "Mot de Passe",
      "passwordPlaceholder": "Entrez le mot de passe",
      "generatePassword": "Générer un Mot de Passe",
      "showPassword": "Afficher le Mot de Passe",
      "hidePassword": "Masquer le Mot de Passe",
      "gender": "Genre",
      "genderPlaceholder": "Sélectionnez le genre",
      "language": "Langue",
      "languagePlaceholder": "Sélectionnez la langue",
      "theme": "Thème",
      "themePlaceholder": "Sélectionnez le thème",
      "platform": "Plateforme",
      "platformPlaceholder": "Sélectionnez la plateforme",
      "pushEnabled": "Notifications Push",
      "pushEnabledDescription": "Activer les notifications push pour cet utilisateur"
    },
    "table": {
      "search": "Rechercher des utilisateurs...",
      "filter": {
        "all": "Tous les Utilisateurs",
        "active": "Actifs",
        "archived": "Archivés",
        "allTypes": "Tous les types"
      },
      "columns": {
        "user": "Utilisateur",
        "email": "Email",
        "type": "Type",
        "status": "Statut",
        "created": "Créé",
        "actions": "Actions"
      },
      "type": {
        "practitioner": "Praticien",
        "institution": "Institution"
      },
      "status": {
        "active": "Actif",
        "archived": "Archivé",
        "noProfile": "Aucun profil"
      },
      "actions": {
        "edit": "Modifier l'Utilisateur",
        "archive": "Archiver l'Utilisateur",
        "activate": "Activer l'Utilisateur",
        "view": "Voir les Détails",
        "impersonate": "Voir en tant que"
      },
      "empty": {
        "title": "Aucun utilisateur trouvé",
        "description": "Aucun utilisateur ne correspond à vos critères de recherche actuels."
      },
      "pagination": {
        "previous": "Précédent",
        "next": "Suivant",
        "page": "Page {{current}} sur {{total}}",
        "showing": "Affichage de {{from}} à {{to}} sur {{total}} utilisateurs"
      }
    },
    "create": {
      "title": "Créer un Nouvel Utilisateur",
      "description": "Ajouter un nouvel utilisateur praticien au système",
      "button": "Ajouter un Utilisateur",
      "form": {
        "basic": "Informations de Base",
        "profile": "Détails du Profil",
        "settings": "Paramètres du Compte",
        "firstName": "Prénom",
        "firstNamePlaceholder": "Entrez le prénom",
        "lastName": "Nom de Famille",
        "lastNamePlaceholder": "Entrez le nom de famille",
        "email": "Adresse Email",
        "emailPlaceholder": "Entrez l'adresse email",
        "phone": "Numéro de Téléphone",
        "phonePlaceholder": "Entrez le numéro de téléphone",
        "password": "Mot de Passe",
        "passwordPlaceholder": "Entrez le mot de passe",
        "generatePassword": "Générer un Mot de Passe",
        "showPassword": "Afficher le Mot de Passe",
        "hidePassword": "Masquer le Mot de Passe",
        "gender": "Genre",
        "genderPlaceholder": "Sélectionnez le genre",
        "language": "Langue",
        "languagePlaceholder": "Sélectionnez la langue",
        "theme": "Thème",
        "themePlaceholder": "Sélectionnez le thème",
        "platform": "Plateforme",
        "platformPlaceholder": "Sélectionnez la plateforme",
        "pushEnabled": "Notifications Push",
        "pushEnabledDescription": "Activer les notifications push pour cet utilisateur"
      },
      "validation": {
        "firstNameRequired": "Le prénom est requis",
        "lastNameRequired": "Le nom de famille est requis",
        "emailRequired": "L'email est requis",
        "emailInvalid": "Veuillez entrer une adresse email valide",
        "passwordRequired": "Le mot de passe est requis",
        "passwordMinLength": "Le mot de passe doit contenir au moins 8 caractères"
      },
      "actions": {
        "cancel": "Annuler",
        "create": "Créer l'Utilisateur"
      }
    },
    "edit": {
      "title": "Modifier l'Utilisateur",
      "description": "Mettre à jour les informations et détails du profil utilisateur",
      "form": {
        "basic": "Informations de Base",
        "profile": "Détails du Profil",
        "settings": "Paramètres du Compte"
      },
      "actions": {
        "cancel": "Annuler",
        "save": "Sauvegarder les Modifications"
      }
    },
    "archive": {
      "title": "Archiver l'Utilisateur",
      "description": "Êtes-vous sûr de vouloir archiver cet utilisateur ? Il ne pourra plus accéder au système.",
      "userName": "Utilisateur : {{name}}",
      "userEmail": "Email : {{email}}",
      "actions": {
        "cancel": "Annuler",
        "archive": "Archiver l'Utilisateur"
      }
    },
    "activate": {
      "title": "Activer l'Utilisateur",
      "description": "Êtes-vous sûr de vouloir activer cet utilisateur ? Il pourra à nouveau accéder au système.",
      "userName": "Utilisateur : {{name}}",
      "userEmail": "Email : {{email}}",
      "actions": {
        "cancel": "Annuler",
        "activate": "Activer l'Utilisateur"
      }
    },
    "options": {
      "gender": {
        "MAN": "Homme",
        "WOMAN": "Femme",
        "OTHER": "Autre"
      },
      "language": {
        "FR": "Français",
        "EN": "Anglais"
      },
      "theme": {
        "SYSTEM": "Système",
        "LIGHT": "Clair",
        "DARK": "Sombre"
      },
      "platform": {
        "WEB": "Web",
        "IOS": "iOS",
        "ANDROID": "Android"
      }
    },
    "detail": {
      "back": "Retour",
      "loading": "Chargement de l'utilisateur...",
      "notFound": "Utilisateur introuvable",
      "noProfile": "Aucun profil",
      "profileSection": "Profil",
      "impersonate": "Voir en tant que"
    }
  },
  "impersonation": {
    "banner": "Vous agissez en tant que {{email}} ({{type}}) — vos actions sont enregistrées à votre nom",
    "quit": "Quitter",
    "roles": {
      "institution": "Institution",
      "practitioner": "Praticien"
    },
    "startFailed": "Impossible de démarrer la consultation en tant qu'utilisateur",
    "stopFailed": "Impossible de restaurer votre session administrateur"
  },
  "success": {
    "userCreated": "Utilisateur créé avec succès",
    "userUpdated": "Utilisateur mis à jour avec succès",
    "userArchived": "Utilisateur archivé avec succès",
    "userActivated": "Utilisateur activé avec succès"
  },
  "errors": {
    "loadUsersFailed": "Échec du chargement des utilisateurs",
    "updateUserFailed": "Échec de la mise à jour de l'utilisateur",
    "archiveUserFailed": "Échec de l'archivage de l'utilisateur",
    "createUserFailed": "Échec de la création de l'utilisateur",
    "impersonateFailed": "Échec du démarrage de la consultation en tant qu'utilisateur"
  }
}
